import React, { useEffect, useState } from 'react';
import { apiClient } from '../../services/api';
import EmptyState from '../shared/EmptyState';
import './RecentActivityFeed.css';

interface ActivityItem {
  type: string;
  description: string;
  user: string;
  timestamp: string;
}

const ICONS: Record<string, string> = {
  run_completed: '▶️',
  run_created: '▶️',
  scenario_created: '📝',
  ai_scenario_created: '✨',
  testcase_created: '✅',
  testcase_updated: '✏️',
};

const timeAgo = (iso: string) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

export const RecentActivityFeed: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<ActivityItem[]>([]);

  useEffect(() => {
    let cancelled = false;
    apiClient.get('/api/v1/dashboard/recent-activity?limit=8')
      .then(resp => { if (!cancelled) setItems((resp.data as any) || []); })
      .catch(() => { if (!cancelled) setItems([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="raf-card">
      <div className="raf-header"><h3>Recent Activity</h3></div>
      {loading ? (
        <div className="raf-skeleton" />
      ) : items.length === 0 ? (
        <EmptyState message="No recent activity." compact />
      ) : (
        <ul className="raf-list">
          {items.map((item, i) => (
            <li key={i} className="raf-item">
              <span className="raf-icon">{ICONS[item.type] || '•'}</span>
              <div className="raf-body">
                <span className="raf-desc">{item.description}</span>
                <span className="raf-meta">{timeAgo(item.timestamp)} · {item.user}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RecentActivityFeed;
